"use client";

import Image from "next/image";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import GlobalForm from "@/components/forms/GlobalForm";
import useModalScrollLock from "@/hooks/useModalScrollLock";
import {
  FinanceAndAccountingSubcategory,
  FormHeading,
  SuccessMessageType,
  VerticalCategory,
} from "@/interface/types";

const officeImages = [
  "https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa/office1.png?tr=f-webp",
  "https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa/office2.png?tr=f-webp",
  "https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa/office3.png?tr=f-webp",
  "https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa/office4.png?tr=f-webp",
  "https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa/office5.png?tr=f-webp",
  "https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa/office6.png?tr=f-webp",
];

interface CityData {
  name: string;
  icon: string;
  address: string;
  email: string;
  phone: string;
  mapUrl: string;
}
interface Coaching_InstituteProps {
  city: string;
  pageName: string;
}

const cities: CityData[] = [
  {
    name: "Bangalore",
    icon: "https://ik.imagekit.io/mileseducation/miles_website/landing-pages/cpa-bengaluru/bangalore.webp",
    address:
      "2nd Floor, Mantri Avenue, 20th Main Rd, Koramangala 8th Block, Koramangala, Bengaluru, Karnataka 560095",
    email: "bangalore@mileseducation.com",
    phone: "+91 95138 81313",
    mapUrl:
      "https://www.google.com/maps?q=Miles+Education+CPA+CMA+Koramangala+8th+Block+Bangalore&t=&z=15&ie=UTF8&iwloc=&output=embed",
  },
  {
    name: "Hyderabad",
    icon: "https://ik.imagekit.io/mileseducation/miles_website/landing-pages/cpa-bengaluru/hyderabad.webp",
    address:
      "Level - 1, Jayabheri Silicon Towers, Hitech City Road, Kothaguda, Hyderabad - 500084",
    email: "hyderabad@mileseducation.com",
    phone: "+91 95138 81313",
    mapUrl:
      "https://www.google.com/maps?q=Miles+Education+CPA+CMA+CAIRA+Hyderabad&ll=17.4585398,78.370688&t=&z=16&ie=UTF8&iwloc=&output=embed",
  },
  {
    name: "Mumbai",
    icon: "https://ik.imagekit.io/mileseducation/miles_website/landing-pages/cpa-bengaluru/mumbai.webp",
    address:
      "1st Floor, AJ House Abengoa, Marol Maroshi Rd, Gamdevi, Marol, Andheri East, Mumbai, Maharashtra 400059",
    email: "mumbai@mileseducation.com",
    phone: "+91 95138 81313",
    mapUrl:
      "https://www.google.com/maps?q=Miles+Education+CPA+CMA+CAIRA+Mumbai&ll=19.1122017,72.8792831&t=&z=16&ie=UTF8&iwloc=&output=embed",
  },
  {
    name: "Delhi",
    icon: "https://ik.imagekit.io/mileseducation/miles_website/landing-pages/cpa-bengaluru/delhi.webp",
    address:
      "3rd and 4th Floor, Old Fort Building, Near DLF Mall, Main Road, Saket, New Delhi, Delhi 110017",
    email: "delhincr@mileseducation.com",
    phone: "+91 95138 81313",
    mapUrl:
      "https://www.google.com/maps?q=Miles+Education+CPA+CMA+CAIRA+Delhi&ll=28.5289753,77.2163721&t=&z=16&ie=UTF8&iwloc=&output=embed",
  },
  {
    name: "Ahmedabad",
    icon: "https://ik.imagekit.io/mileseducation/miles_website/landing-pages/cpa-bengaluru/ahmedabad.webp",
    address:
      "704 Satyaone Complex, Near Helmet Cross Road, Memnagar, Ahmedabad - 380052",
    email: "ahmedabad@mileseducation.com",
    phone: "+91 95138 81313",
    mapUrl:
      "https://www.google.com/maps?q=Satyaone+Complex+Memnagar+Ahmedabad&t=&z=15&ie=UTF8&iwloc=&output=embed",
  },
  {
    name: "Kochi",
    icon: "https://ik.imagekit.io/mileseducation/miles_website/landing-pages/cpa-bengaluru/kochi.webp",
    address:
      "11th Floor, Muthoottu Royal Tower, 36, Banerji Road, Kaloor, Ernakulam, Kerala 682017",
    email: "kochi@mileseducation.com",
    phone: "+91 95138 81313",
    mapUrl:
      "https://www.google.com/maps?q=Muthoottu+Royal+Tower+Banerji+Road+Ernakulam+Kerala&t=&z=15&ie=UTF8&iwloc=&output=embed",
  },
  {
    name: "Kolkata",
    icon: "https://ik.imagekit.io/mileseducation/miles_website/landing-pages/cpa-bengaluru/kolkata.webp",
    address:
      "Collab Deck, 2/1, Russel St, Kankaria Estates, Park Street area, Kolkata, West Bengal 700071",
    email: "kolkata@mileseducation.com",
    phone: "+91 95138 81313",
    mapUrl:
      "https://www.google.com/maps?q=Collab+Deck+Russel+Street+Kankaria+Estates+Kolkata&t=&z=15&ie=UTF8&iwloc=&output=embed",
  },
  {
    name: "Pune",
    icon: "https://ik.imagekit.io/mileseducation/miles_website/landing-pages/cpa-bengaluru/pune.webp",
    address:
      "Sprint Workspace Wakadewadi, Old Mumbai - Pune Hwy, Narveer Tanaji Wadi, Shivajinagar, Pune, Maharashtra 411005",
    email: "pune@mileseducation.com",
    phone: "+91 95138 81313",
    mapUrl:
      "https://www.google.com/maps?q=Sprint+Workspace+Wakadewadi+Old+Mumbai+Pune+Hwy+Narveer+Tanaji+Wadi+Shivajinagar+Pune+Maharashtra+411005&t=&z=15&ie=UTF8&iwloc=&output=embed",
  },
  {
    name: "Chennai",
    icon: "https://ik.imagekit.io/mileseducation/miles_website/landing-pages/cpa-bengaluru/chennai.webp",
    address:
      "3rd Floor, 91 Springboard, Etica Malar Aurum, B-12, Guindy Industrial Estate, SIDCO Industrial Estate, Guindy, Chennai, Tamil Nadu 600032",
    email: "chennai@mileseducation.com",
    phone: "+91 95138 81313",
    mapUrl:
      "https://www.google.com/maps?q=91+Springboard+Etica+Malar+Aurum+B-12+Guindy+Industrial+Estate+SIDCO+Industrial+Estate+Guindy+Chennai+Tamil+Nadu+600032&t=&z=15&ie=UTF8&iwloc=&output=embed",
  },
];

const IMAGE_FADE_DURATION_MS = 120;

const Coaching_Institute: React.FC<Coaching_InstituteProps> = ({
  city,
  pageName,
}) => {
  const [activeImage, setActiveImage] = useState(officeImages[0]);
  const [activeCity, setActiveCity] = useState<CityData>(
    () => cities.find((c) => c.name === city) ?? cities[0],
  );
  const [isHovered, setIsHovered] = useState(false);
  const [isFading, setIsFading] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const fadeTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useModalScrollLock(isFormOpen, {
    restoreScrollPosition: true,
    preventTouchScroll: true,
  });

  const clearFadeTimeout = useCallback(() => {
    if (fadeTimeoutRef.current) {
      clearTimeout(fadeTimeoutRef.current);
      fadeTimeoutRef.current = null;
    }
  }, []);

  const queueImageChange = useCallback(
    (image: string) => {
      if (image === activeImage) return;
      clearFadeTimeout();
      setIsFading(true);
      fadeTimeoutRef.current = setTimeout(() => {
        setActiveImage(image);
        setIsFading(false);
        fadeTimeoutRef.current = null;
      }, IMAGE_FADE_DURATION_MS);
    },
    [activeImage, clearFadeTimeout],
  );

  useEffect(() => {
    if (isHovered) return;
    intervalRef.current = setInterval(() => {
      const currentIndex = officeImages.indexOf(activeImage);
      const nextIndex = (currentIndex + 1) % officeImages.length;
      queueImageChange(officeImages[nextIndex]);
    }, 3000);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [activeImage, isHovered, queueImageChange]);

  useEffect(() => {
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
      clearFadeTimeout();
    };
  }, [clearFadeTimeout]);

  const activeIndex = officeImages.indexOf(activeImage);

  const handlePrevImage = () => {
    const prevIndex =
      (activeIndex - 1 + officeImages.length) % officeImages.length;
    queueImageChange(officeImages[prevIndex]);
  };

  const handleNextImage = () => {
    const nextIndex = (activeIndex + 1) % officeImages.length;
    queueImageChange(officeImages[nextIndex]);
  };

  const peekImage = officeImages[(activeIndex + 1) % officeImages.length];

  const directionsUrl = useMemo(
    () =>
      `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
        activeCity.address,
      )}`,
    [activeCity.address],
  );

  return (
    <>
      <section className="bg-white pb-8 md:py-[50px] px-4 max-md:bg-[#f3f3f3]">
        <div className="main_container py-5 md:py-0 bg-white rounded-2xl">
          <div className="mb-8 max-md:mb-6">
            <h2 className="m-0 mb-2 text-xl md:text-[32px] text-center font-bold leading-[1.25] text-[#39F]">
              Best {pageName} Coaching Institute in India
            </h2>
            <p className="m-0 text-sm font-normal text-center leading-normal tracking-[-0.3px] text-[#333]">
              Centers across 9 cities and 3 countries
            </p>
          </div>

          {/* Mobile city pills */}
          <div className="hidden max-md:flex gap-2.5 overflow-x-auto pb-1.5 mb-5 [-webkit-overflow-scrolling:touch] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
            {cities.map((city) => (
              <button
                key={city.name}
                type="button"
                onClick={() => setActiveCity(city)}
                className={`shrink-0 whitespace-nowrap rounded-3xl border px-[18px] py-2 text-sm font-medium transition-all duration-200 ${
                  activeCity.name === city.name
                    ? `bg-[#3A73AC] border-transparent text-white`
                    : "border-[#dee7f5] bg-white text-[#132a52]"
                }`}
              >
                {city.name}
              </button>
            ))}
          </div>

          <div className="flex items-start gap-7 max-md:flex-col max-md:gap-4">
            {/* Desktop sidebar */}
            <div className="flex w-[240px] shrink-0 flex-col overflow-hidden border-r border-[#eef1f8] max-md:hidden">
              {cities.map((city) => (
                <button
                  key={city.name}
                  type="button"
                  onClick={() => setActiveCity(city)}
                  className={`flex w-full items-center gap-3 border-b border-[#eef1f8] border-l-[3px] bg-white px-4 py-3.5 text-left transition-all duration-200 last:border-b-0 ${
                    activeCity.name === city.name
                      ? "border-l-[#2f89ea] bg-[#F6FBFF]"
                      : "border-l-transparent hover:bg-[#f0f2fb]"
                  }`}
                >
                  <Image
                    src={city.icon}
                    alt={`${city.name} icon`}
                    width={32}
                    height={32}
                    loading="lazy"
                    className="h-8 w-8 shrink-0 object-contain"
                  />
                  <span className="flex min-w-0 flex-col gap-1">
                    <span className="text-sm font-normal text-[#000]">
                      {city.name}
                    </span>
                  </span>
                </button>
              ))}
            </div>

            {/* Content: map + details */}
            <div className="flex min-w-0 flex-1 flex-col gap-5">
              <div className="h-[450px] overflow-hidden rounded-2xl max-md:-mx-4 max-md:h-[230px] max-md:w-[calc(100%+32px)] max-md:rounded-none">
                <iframe
                  key={activeCity.mapUrl}
                  src={activeCity.mapUrl}
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title={`${activeCity.name} office map`}
                  className="block"
                />
              </div>

              <div className="flex items-start gap-6 max-md:flex-col max-md:gap-6">
                <div className="min-w-0 flex-1">
                  <h3 className="m-0 mb-3 flex items-center gap-2.5 text-[22px] max-md:text-[19px] font-bold text-[#3A73AC]">
                    <Image
                      src={activeCity.icon}
                      alt=""
                      width={50}
                      height={50}
                      className="hidden max-md:block h-[50px] w-[50px] object-contain"
                    />
                    {activeCity.name}
                  </h3>
                  <p className="m-0 mb-3.5 text-[15px] leading-[1.6] text-[#333]">
                    {activeCity.address}
                  </p>

                  <div className="mb-2.5 flex items-start gap-2 text-sm font-normal leading-[1.6] text-[#333]">
                    <svg
                      className="mt-0.5 h-4 w-4 shrink-0 text-[#333]"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                      <polyline points="22,6 12,13 2,6" />
                    </svg>
                    <a
                      href={`mailto:${activeCity.email}`}
                      className="hover:text-[#3399ff] transition-colors"
                    >
                      {activeCity.email}
                    </a>
                  </div>

                  <div className="mb-2.5 flex items-start gap-2 text-sm font-normal leading-[1.6] text-[#333]">
                    <svg
                      className="mt-0.5 h-4 w-4 shrink-0 text-[#555]"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12.7a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.61a16 16 0 0 0 6 6l.93-.93a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
                    </svg>
                    <a
                      href={`tel:${activeCity.phone.replace(/\s/g, "")}`}
                      className="hover:text-[#3399ff] transition-colors"
                    >
                      {activeCity.phone}
                    </a>
                  </div>

                  <div className="mt-5 flex gap-3 max-md:gap-2.5">
                    <a
                      href={directionsUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`inline-flex w-[200px] items-center justify-center rounded-[12px_12px_12px_0] px-[22px] py-2 text-[15px] font-semibold text-white transition-opacity hover:opacity-85 bg-[#2A85FF] max-md:flex-1 max-md:px-2.5 max-md:text-sm`}
                    >
                      Get Direction
                    </a>
                    <button
                      type="button"
                      onClick={() => setIsFormOpen(true)}
                      className="inline-flex items-center justify-center bg-white px-[22px] text-[15px] font-semibold text-[#2A85FF] transition-opacity hover:opacity-85 max-md:flex-1 max-md:px-2.5 max-md:text-sm underline"
                    >
                      Book a visit
                    </button>
                  </div>
                </div>

                {/* Gallery card */}
                <div
                  className="flex w-[300px] shrink-0 flex-col items-center gap-4 max-md:mx-auto max-md:w-full "
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                >
                  <div
                    className="relative mt-2.5 w-full"
                    style={{ aspectRatio: "385 / 255" }}
                  >
                    <div
                      className="absolute rounded-[14px] border-4 border-white bg-cover bg-center shadow-[0_8px_20px_rgba(15,23,42,0.12)] z-[1]"
                      style={{
                        inset: "4px -6px -6px 4px",
                        transform: "rotate(6deg)",
                        backgroundImage: `url(${peekImage}&tr=w-260,h-170,q-50)`,
                      }}
                    />
                    <div className="relative z-[2] h-full w-full overflow-hidden rounded-[14px] border-4 border-white bg-[#0b1020] shadow-[0_10px_24px_rgba(15,23,42,0.18)]">
                      <Image
                        src={`${activeImage}&tr=w-385,h-255,q-60`}
                        alt="Pan India Office Preview"
                        width={385}
                        height={255}
                        className={`block h-full w-full object-cover transition-opacity duration-150 ${
                          isFading ? "opacity-0" : "opacity-100"
                        }`}
                        loading="lazy"
                        sizes="(max-width: 767px) 320px, 300px"
                      />
                    </div>
                  </div>

                  <div className="flex items-center gap-3.5">
                    <button
                      type="button"
                      onClick={handlePrevImage}
                      aria-label="Previous office image"
                      className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-[#dee7f5] bg-white p-0 text-[#3399ff] transition-all duration-200 hover:border-[#3399ff] hover:bg-[#f0f2fb]"
                    >
                      <svg
                        className="h-4 w-4"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <path
                          d="M15 18l-6-6 6-6"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>

                    <div className="flex items-center gap-1.5">
                      {officeImages.map((image) => (
                        <button
                          key={image}
                          type="button"
                          onClick={() => queueImageChange(image)}
                          aria-label="Show office image"
                          className={`h-1.5 rounded-[5px] border-0 p-0 transition-all duration-200 ${
                            activeImage === image
                              ? `w-5 bg-[#3A73AC]`
                              : "w-1.5 bg-[#e4e8f8]"
                          }`}
                        />
                      ))}
                    </div>

                    <button
                      type="button"
                      onClick={handleNextImage}
                      aria-label="Next office image"
                      className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-[#dee7f5] bg-white p-0 text-[#3399ff] transition-all duration-200 hover:border-[#3399ff] hover:bg-[#f0f2fb]"
                    >
                      <svg
                        className="h-4 w-4"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <path
                          d="M9 18l6-6-6-6"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {isFormOpen && (
        <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/80 p-4 lg:p-10">
          <div
            className="relative mx-auto h-auto w-[400px] rounded-2xl border border-white p-4 shadow-lg"
            style={{
              background:
                "linear-gradient(180deg, rgba(255, 255, 255, 0.30) 0%, rgba(51, 153, 255, 0.30) 100%)",
              boxShadow: "0px 0px 14px 0px rgba(4, 84, 175, 0.29)",
              backdropFilter: "blur(28px)",
            }}
          >
            <button
              type="button"
              onClick={() => setIsFormOpen(false)}
              className="absolute right-0 top-1 cursor-pointer text-2xl text-white"
            >
              ✕
            </button>
            <div>
              <Image
                src="https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-visit/starGroup.webp"
                alt="star group"
                width={34}
                height={38}
                className="absolute left-[-8px] top-3"
                loading="lazy"
              />
              <GlobalForm
                course={pageName}
                courseId={pageName === "CPA" ? 1 : 2}
                formHeading={
                  FormHeading.SCHEDULE_A_VISIT_TO_MILES_OFFICE_OR_MEET_US_ONLINE
                }
                formType="page"
                isAStepperForm={true}
                pageType="accounting page"
                subCategory={FinanceAndAccountingSubcategory.CPA}
                submitButtonName="Start Your Journey"
                successMessage={SuccessMessageType.ACCOUNTING}
                verticalName={VerticalCategory.FINANCE_AND_ACCOUNTING}
                darkBackground={true}
                defaultCityLocation={activeCity.name}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Coaching_Institute;
